module.exports = __webpack_public_path__ + "img/17-ABITO-AGADI-SML-STAMPE-LINO-UNITI-LINO5.fe5fd1d9.jpg";